import "./BirksBusinessNetwork.module.css";
import Header from "@/reusable_sections/Header";
import FormHeader from "./sections/FormHeader";
import BusinessNetworkMultiStepForm from "./sections/BusinessNetworkMultiStepForm";
import Footer from "@/reusable_sections/Footer";
export default function BirksBusinessNetworkPage() {
  return <div>
      <Header />
      <FormHeader />
      <BusinessNetworkMultiStepForm />
      <Footer />
    </div>;
}